module.exports = __webpack_public_path__ + "img/brackets-x.423b8c98.svg";